module.exports = __webpack_public_path__ + "img/logo-dark.9ee8ea65.png";